module.exports = __webpack_public_path__ + "img/trip_12.5158a54a.jpg";